import { Option, SourcedValue } from './option.js';
import { optionIdSymbol, typeSymbol } from './engine-impl.js';
import { Product } from './product.js';
import { BigNumber, MLString, SystemType, TypeReference } from './types.js';
import SearchCriteriaBuilder from './DataSetService/SearchCriteriaBuilder.js';

export { RecordKind } from './record.js';

export { PropertyChanges, IOptionCorrection } from './services/notifications/LookupMutatorCorrectionEvent.js';

export { ProductWithContext } from './dataset.js';

export { AutoCorrectPropertyEvent } from './services/notifications/AutoCorrectModelEvents.js';

export { ExternalFieldRegistry } from './services/ExternalFieldRegistry.js';

export { LanguageService } from './services/LanguageService.js';

export { engineUtils } from './services/EngineUtils.js';

export { Schema, SchemaTypeRef } from './schema.js';

export { deepCopy } from './deep-copy.js';

export { PrimitiveType, SystemType, Type, TypeKind } from './types.js';

export { PropertyPath } from './engine.js';

export { PropertyPathWalker } from './internal/PropertyPathWalker.js';

export { ModelSystemProperties } from './internal/ModelSystemProperties.js';

export { Option, OptionGroup, SourcedValue } from './option.js';

export { YamlDatasetService } from './DataSetService/YamlDatasetService.js';

export { DatasetService } from './dataset.js';

export { Product, ProductGroup } from './product.js';

export {
  ObjectType, ExternalField, ListType, EnumType, UnionType, Property, TypeReference, MLString, BigNumber
} from './types.js';

export {
  Model, PModel, ModelMutator, ValidationResult, MutatorContext, POption, IEntitySearchResult, POptionGroup
} from './engine.js';

export { SinglePropertyMutator } from './internal/SinglePropertyMutator.js';
export { TransactionalMutator } from './internal/TransactionalMutator.js';

export { PrototypeTraverser, SimpleVisitor } from './internal/PrototypeVisitor.js';

export { APIResult, APIRegistry, API, PluginBase } from './plugin.js';
export { ConstraintInstance } from './constraint.js';
export { ModelErrorCode } from './errors/ModelError.js';

export { FlatStructuralTransformer } from './services/transformers/FlatStructuralTransformer.js';
export { IdentityStructuralTransformer } from './services/transformers/IdentityStructuralTransformer.js';

export { FlatProductTransformer, HierarchicalProductTransformer } from './services/transformers/ProductTransformer.js';

export { LookupMutator } from './mutators/LookupMutator.js';
export { JsExpressionConstraint } from './constraint.js';
export { SearchCriteriaBuilder };

export { ModelNotificationEvent } from './services/notifications/ModelNotificationEvent.js';
export { LookupMutatorCorrectionEvent } from './services/notifications/LookupMutatorCorrectionEvent.js';
export { LookupId } from './engine.js';

export { IDataFileValidator } from './DataSetService/visitors/IDataFileValidator.js';
export { YamlExporterVisitor } from './DataSetService/visitors/YamlExporterVisitor.js';

export {
  Doc, Dataset,
  DocOption, DocOptionGroup,
  DocProduct, DocProductGroup,
  DocCompatibilityTable, DocOclFilter, DocJsFilter, DocOclConstraint, DocExternalField
} from './DataSetService/visitors/DataFile.js';

export function useTypeFrom(o1: any, o2: any) {
  o1[typeSymbol] = o2[typeSymbol];
}

export function getTypeRef(o: any) {
  if (typeof o === 'string') {
    return 'string';
  }
  if (typeof o === 'number') {
    return 'number';
  }
  if (typeof o === 'boolean') {
    return 'boolean';
  }
  if (o instanceof MLString) {
    return 'mlstring';
  }
  if (o instanceof BigNumber) {
    return 'bignumber';
  }
  return o[typeSymbol] as TypeReference;
}

export function getOptionId(o: any) {
  return o ? o[optionIdSymbol] : undefined;
}

export const getProductId = getOptionId;
export const getProductGroupId = getProductId;

export {
  EngineImpl as Engine,
  EngineInternalAPI,
  typeSymbol
} from './engine-impl.js';
// As a workaround optionIdSymbol is marked as optional
export type WithOptionId<T> = T & { [optionIdSymbol]?: string };
export { ObjectHashSet } from './lookup/ObjectHashSet.js';

export { YamlTransformer } from './DataSetService/YamlTransformer.js';
export { AsyncJsDatasetService } from './DataSetService/AsyncJsDatasetService.js';
export { AsyncYamlDatasetService } from './DataSetService/AsyncYamlDatasetService.js';
export { OptionDefinition, ProductDefinition, OptionGroupDefinition } from './DataSetService/yaml-models.js';
export { isPropertyRequired } from './constraint.js';



